<template>
    <q-dialog
        v-model="isOpen"
        content-class="assign-course"
        @input="toggleDialog"
    >
        <q-card class="q-pa-md">
            <q-card-section>
                <h4>{{ $t('actions.assign_course') }}</h4>
            </q-card-section>
            <q-card-section>
                <div class="form-warp">
                    <q-form>
                        <p
                            class="q-mb-sm text-capitalize text-left q-mt-md q-px-sm"
                        >
                            <span class="text-bold"
                                >{{ $t('general.course') }}:</span
                            >
                            {{ courseTitle }}
                        </p>
                        <div class="course-allowance text-left q-mt-md q-px-sm">
                            <span class="text-bold"
                                >{{ $t('profile.courses_avaliable') }}:</span
                            >
                            {{ coursesAvailableToGive }}
                        </div>
                        <AssignEmployeeTable
                            class="q-mt-lg"
                            :columns="columns"
                            :users-affiliated="users"
                            :users-with-course="usersWithCourse"
                            :order-item-course="orderItem"
                            :pagination.sync="pagination"
                            :filter="filter.search"
                            :loading="isFetchingAffiliatedUsers"
                            :courses-available-to-give="coursesAvailableToGive"
                            @assign-course="assignCourse"
                            @request="onRequest"
                        >
                            <template v-slot:top>
                                <div class="col-12">
                                    <div
                                        class="filter-wrap row q-col-gutter-sm"
                                    >
                                        <div class="col">
                                            <q-input
                                                v-model="filter.search"
                                                debounce="300"
                                                :label="$t('actions.search')"
                                                outlined
                                                dense
                                                clearable
                                                :placeholder="`${$t(
                                                    'general.name'
                                                )} ${$t('general.or')} ${$t(
                                                    'general.email'
                                                )}`"
                                                @input="resetPagination"
                                            >
                                                <template v-slot:append>
                                                    <q-icon name="search" />
                                                </template>
                                            </q-input>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </AssignEmployeeTable>
                    </q-form>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import AssignEmployeeTable from '@/components/AssignEmployeeTable'
import notify from '@/local-shared/mixins/notify'
import librariesService from '@/services/modules/libraries'
import affiliationsService from '@/services/modules/profile/affiliations'
import store from '@/store'

const loadingKeys = {
    fetchingAffiliatedUsers: 'fetching-affiliated-users',
    fetchingUsersWithCourse: 'fetching-users-with-course',
    savingLibrary: 'saving-library',
}

export default {
    name: 'AssignEmployee',

    components: {
        AssignEmployeeTable,
    },

    mixins: [notify],

    props: {
        show: {
            type: Boolean,
            default: false,
        },

        client: {
            type: Object,
            default: () => {},
        },

        orderItem: {
            type: Object,
            default: () => {},
        },

        roleId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            isOpen: false,

            users: [],
            usersWithCourse: [],

            filter: {
                search: '',
            },

            pagination: {
                sortBy: 'first_name',
                descending: false,
                page: 1,
                rowsPerPage: 20,
            },
        }
    },

    computed: {
        columns() {
            return [
                {
                    name: 'first_name',
                    label: this.$tc('general.name'),
                    field: (row) => row.users.first_name,
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'email',
                    label: this.$tc('general.email'),
                    field: (row) => row.users.email,
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'assigned_in_this_order',
                    label: this.$tc('general.assigned_in_this_order'),
                    field: (row) => row.users.libraries,
                    align: 'right',
                    sortable: false,
                },
                {
                    name: 'assigned_outside_this_order',
                    label: this.$tc('general.assigned_outside_this_order'),
                    field: (row) => row.users.libraries,
                    align: 'right',
                    sortable: false,
                },
                {
                    name: 'actions',
                    label: this.$t('general.assign'),
                    field: 'actions',
                },
            ]
        },

        isFetchingRoles() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingRoles
            ).length
        },

        isFetchingAffiliatedUsers() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingAffiliatedUsers
            ).length
        },

        isFetchingUsersWithCourse() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingUsersWithCourse
            ).length
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        courseTitle() {
            return this.orderItem &&
                this.orderItem.courses &&
                this.orderItem.courses.title
                ? JSON.parse(this.orderItem.courses.title)[this.locale.key]
                : ''
        },

        coursesAvailableToGive() {
            return this.orderItem &&
                this.orderItem.quantity &&
                this.orderItem.libraries
                ? this.orderItem.quantity - this.orderItem.libraries.length
                : 0
        },
    },

    watch: {
        async show(value) {
            if (value === true) {
                await this.fetchAffiliatedUsers()
            }
            this.isOpen = value
        },
    },

    methods: {
        resetPagination() {
            this.pagination.page = 1
            this.fetchAffiliatedUsers()
        },

        toggleDialog() {
            this.$emit('toggle-dialog', !this.isOpen)
        },

        onRequest(paginationAux, filterAux) {
            this.filter.search = filterAux
            this.pagination = paginationAux
            this.fetchAffiliatedUsers()
        },

        mapColumn(value) {
            return value == null ? this.pagination.sortBy : value
        },

        mapOrder(value) {
            return value == true ? 'desc' : 'asc'
        },

        async fetchAffiliatedUsers() {
            this.loadingAdd(loadingKeys.fetchingAffiliatedUsers)

            let parameters = {
                filter: {
                    search: this.filter.search,
                    active: true,
                    userRoleId: this.roleId,
                    clientId: this.client.affiliations[0].client_id,
                    librariesCoursesIn: [this.orderItem.course_id],
                },
                pagination: {
                    perPage: this.pagination.rowsPerPage,
                    currentPage: this.pagination.page,
                },
                orderBy: [
                    {
                        column: this.mapColumn(this.pagination.sortBy),
                        direction: this.mapOrder(this.pagination.descending),
                    },
                ],
            }

            let response = await affiliationsService.users.retrieve(parameters)

            if (response.status === 200) {
                this.users = response.data.results
                this.pagination.rowsNumber = response.data.pagination.total
            } else {
                this.notifyError(response)
            }

            this.loadingRemove(loadingKeys.fetchingAffiliatedUsers)
        },

        mapLibraryRequest(payload) {
            return {
                data: [
                    {
                        course_id: payload.course.course_id,
                        user_id: payload.user.user_id,
                        order_id: this.orderItem.order_id,
                        order_item_id: this.orderItem.id,
                        progress: 0,
                        rate: null,
                    },
                ],
            }
        },

        async assignCourse(payload) {
            this.loadingAdd(loadingKeys.savingLibrary)

            let parameters = this.mapLibraryRequest(payload)
            let response = await librariesService.assign(parameters)
            if (response.status === 200) {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.course_assigned_to_user'),
                })
                this.$emit('refresh', { orderItemId: this.orderItem.id })
            } else {
                this.notifyError(response)
            }

            this.loadingRemove(loadingKeys.savingLibrary)
        },
    },
}
</script>
